export default __webpack_public_path__ + "35.png";